import { render, staticRenderFns } from "./ForcePassword.vue?vue&type=template&id=4f803314"
import script from "./ForcePassword.vue?vue&type=script&lang=js"
export * from "./ForcePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f803314')) {
      api.createRecord('4f803314', component.options)
    } else {
      api.reload('4f803314', component.options)
    }
    module.hot.accept("./ForcePassword.vue?vue&type=template&id=4f803314", function () {
      api.rerender('4f803314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/ForcePassword.vue"
export default component.exports